import React from 'react';
import {Button, Link} from "@mui/material";
import { withStyles } from "@mui/styles";
import {PlayArrow} from "@mui/icons-material";
import {FilterIcon, SurveyAttemptIcon} from "../../../../../helpers/Icons";
import DateDisplay from "../../../../../helpers/common/DateDisplay";
import HelpInfoButton from "./HelpInfoButton";

const styles = {
  root:{
    display: "flex",
    gap: "0.25rem",
    padding: "0.25rem 0 0 0.5rem",
  },
  column:{
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    flex: 1,
  },
  columnNoGap:{
    display: "flex",
    flexDirection: "column",
  },
  row:{
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    flex: 1,
  },
  rowCentered:{
    display: "flex",
    flexWrap: "wrap",
    gap: "0 0.75rem",
    alignItems: "center",
  },
  rowWrap:{
    display: "flex",
    gap: "0.5rem",
    flexWrap: "wrap",
    // alignItems: "center",
  },
  icon: {
    alignSelf: "flex-start",
    // marginTop: "6.25px",
    // fontSize: "1.75rem !important",
    '& > svg':{
      color: '#005985',
      width: '1.75rem',
      maxHeight: '34px',
      height: '100%',
      fontSize: 'inherit',
      margin: '0em 0.35em 0 0',
      alignSelf: 'first baseline',
      paddingTop: '0px',
    }
  },
  name: {
    // fontSize: "1.15rem",
    fontWeight: 600,
    color: "#003e58",
    whiteSpace: "nowrap",
    minWidth: "calc(min((100% - 7rem), 12rem))",
  },
  questions: {
    fontSize: "0.7225rem",
    textTransform: "uppercase",
    fontWeight: 600,
    color: "#003e58",
  },
  description: {
    // flexBasis: "calc(min(100%, 40rem))",
    flex: 1,
    minWidth: "calc(min(25rem, 100%))",
    width: "100",
    fontSize: "0.85rem"
  },
  field: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.15rem",
    alignItems: "center",
    // fontWeight: 300,
    fontSize:'0.85em',
    // overflow:'hidden',
    // textOverflow:'ellipsis',
    // textAlign:'center'
  },
  label: {
    fontSize:'0.7225rem',
    fontWeight: 600,
    color: '#003e58',
    textTransform: 'uppercase',
    lineHeight: '1.35em',
  },
  button: {
    textDecoration: "underline",
    fontWeight: 400,
    padding: "0 0.15rem",
    lineHeight: "1.5em",
  },
  buttonRow: {
    display: "flex",
    gap: "0.5rem",
  },
  iconSmall: {
    fontSize: "1rem !important"
  },
  completed: {
    // backgroundColor: "rgba(206, 244, 179, 0.69)",
    backgroundColor: "rgb(133, 238, 59, 0.75)",
  },
  started: {
    // backgroundColor: "rgb(249, 248, 222)",
    backgroundColor: "rgb(255, 249, 84, 0.75)",
  },
};


export function surveyStatus(survey){
  return typeof (survey.attempts?.answer_count) === "undefined" ? -1
    : survey.attempts?.answer_count >= survey.question_count ? 1
    : survey.attempts?.answer_count / survey.question_count;
}

function SurveyAttempts({survey, filterName, openDataView, status, classes}) {
  return <div className={classes.rowCentered}>
    <div className={classes.field}>
      <span className={classes.label}>
        Status:
      </span>
      <span id="surveyStatus">
        {status === -1 ? "Not Started"
          : status === 1 ? "Completed"
          : "In Progress"
        } ({survey.attempts?.answer_count || 0}/{survey.question_count})
      </span>
    </div>
    {!survey.attempts ? null : <>
      <div className={classes.field}>
        <span className={classes.label}>
          Times taken:
        </span>
        <span>
          <Button
            id="surveyAttemptsCount"
            color='inherit'
            className={classes.button}
            component={Link}
            size={"small"}
            onClick={(e) => filterName(survey.name)}
          ><span id="surveyAnswered">{survey.attempts?.count || 0}</span> - <FilterIcon className={classes.iconSmall}/> Filter</Button>
        </span>
      </div>
      <div className={classes.field}>
        <span className={classes.label}>
          Latest Attempt:
        </span>
        <span>
          <Button
            id="surveyLatestAttempt"
            color='inherit'
            component={Link}
            className={classes.button}
            size={"small"}
            onClick={() => openDataView(survey.attempts?.item_id)}
          >
            <DateDisplay date={survey.attempts?.created_at} timeSize={"large"}/>
          </Button>
        </span>
      </div>
    </>}
  </div>
}

function SurveyOption(props) {
  const {helpIndex, survey, startSurvey, openDataView, classes} = props;
  const status = surveyStatus(survey);

  return (
    <div className={`${classes.root} ${status === 1 ? classes.completed : status >= 0 ? classes.started : ""}`}>
      <div className={classes.icon}>
        <SurveyAttemptIcon />
      </div>
      <div className={classes.column}>
        <div className={classes.row}>
          <div className={classes.rowWrap}>
            <div className={classes.columnNoGap}>
              <div className={classes.name}>
                <span id="surveyName">{survey.name}</span>
                <HelpInfoButton helpIndex={helpIndex} />
              </div>
              <div id="surveyQuestionCount" className={classes.questions}>
                ({survey.question_count} questions)
              </div>
            </div>
            <div className={classes.buttonRow}>
              <div>
                <Button
                  id="surveyStart"
                  className={classes.start}
                  variant="contained"
                  color={"primary"}
                  size={"small"}
                  endIcon={<PlayArrow/>}
                  onClick={(e) => startSurvey(survey => openDataView?.(survey.mindfile_item.id))}
                >Start New</Button>
              </div>
            {status === -1 || status === 1 ? null :
              <div>
                <Button
                  id="surveyResume"
                  className={classes.start}
                  variant="contained"
                  color={"secondary"}
                  size={"small"}
                  endIcon={<PlayArrow/>}
                  onClick={() => openDataView(survey.attempts?.item_id)}
                >Resume</Button>
              </div>
            }
            </div>
          </div>
          <div id="surveyDescription" className={classes.description}>
            {survey.description || ""}
          </div>
        </div>
        <SurveyAttempts {...props} status={status} />
      </div>
    </div>
  );
}

export default withStyles(styles)(SurveyOption);
